<!--
 * @Author: DQL
 * @Date: 2020-03-09 17:00:21
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-06 10:50:42
 * @Description: file content
 -->
<template>
  <div
    class="c-login-wrap"
  >
    <div
      class="c-login__main"
    >
      <h2
        class="c-login__title"
      >
        <img :src="appLogo">
        <span>{{ appName }}</span>
      </h2>
      <div
        class="l-login__body"
      >
        <div
          v-loading="logining"
          class="c-login__form-wrap"
          element-loading-text="正在登入，请稍后……"
        >
          <div
            class="c-login__form-title"
          >
            用户登录
          </div>
          <el-form
            ref="fd"
            class="c-login__form"
            :model="fd"
            :rules="fdRules"
            size="normal"
            label-width="0px"
          >
            <el-form-item
              prop="account"
            >
              <el-input
                v-model.trim="fd.account"
                type="text"
                prefix-icon="el-icon-user"
                placeholder="请输入用户名"
                @keyup.native.enter="handleSubmit"
              />
            </el-form-item>
            <el-form-item
              prop="password"
            >
              <el-input
                v-model="fd.password"
                type="password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                @keyup.native.enter="handleSubmit"
              />
            </el-form-item>
            <!-- <el-form-item
              class="o-forget-pass-bar"
            >
              <span
                class="u-pointer"
                @click="$router.push({path: '/forgetPassword'})"
              >忘记密码？</span>
            </el-form-item> -->
            <el-form-item
              class="o-login-bar"
            >
              <el-button
                size="normal"
                type="primary"
                style="width: 100%;"
                :loading="logining"
                @click.native.prevent="handleSubmit"
              >
                <span class="u-mg-l-12">登录</span>
              </el-button>
            </el-form-item>
            <!-- <el-form-item
              class="o-register-bar"
            >
              <el-divider>
                <span
                  class="o-register-link"
                  @click="$router.push({name: 'register'})"
                >立即注册</span>
              </el-divider>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>
    <div
      class="l-login__footer"
    >
      <small
        class="c-login__copyright"
      >{{ cr }}</small>
    </div>
  </div>
</template>

<script>
import config from '@/config.js';
import { loginSys } from '@/features/feature.common.service';

export default {
  name: 'Login',
  data () {
    return {
      appLogo: process.env.BASE_URL + 'assets/logo2.png',
      appName: config.app.name,
      cr: config.copyright,
      logining: false, // 登录ing

      /* 表单参数 Start */
      fd: {
        account: '',
        password: '',
        appDm: 'PCAPP'
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      /* 表单校验规则 End */
      loginError: false
    };
  },
  computed: {
    // 用户信息
    currentUser () {
      return this.$HMStoreService.getUserinfo();
    }
  },
  methods: {
    /**
     * @description: 登录
     * @param {*}
     * @return {*}
     */
    handleSubmit (ev) {
      if (this.loginError) {
        return;
      }
      if (ev !== undefined) {
        ev.srcElement.blur();
      }
      const _this = this;
      this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.logining = true;
          // 清除cookie，防止用户直接关闭标签操作，重新登录且cookie没更新
          _this.$HMCookies.unset(config.localTokenName);
          loginSys(_this.fd)
            .then(rsp => {
              const userinfo = rsp.data;
              console.log('userinfo', userinfo);

              const token = rsp.headers[config.serverHeaderTokenName];
              _this.$HMCookies.set(config.localTokenName, token);

              _this.$HMStoreService.updateUserinfo(userinfo); // 更新用户信息
              _this.$HMStoreService.updateMenu(userinfo.menuTree); // 更新用户权限菜单树
              _this.handleLoginSuccess(userinfo);
            })
            .catch(err => {
              if (err.data.errorCode === '4010' || err.data.errorCode === '4000') {
                _this.loginError = true;
                _this.$alert(err.data.errorMsg, '提示', {
                  confirmButtonText: '确定',
                  type: 'error',
                  callback: action => {
                    _this.loginError = false;
                  }
                });
              }
            })
            .finally(() => {
              _this.logining = false;
            });
        }
      });
    },
    /**
     * @description: 登录成功处理事件
     * @param {*}
     * @return {*}
     */
    handleLoginSuccess (_userinfo) {
      // 登录后用户信息没有身份信息，跳转选身份页面
      if (!_userinfo.capacity) {
        this.$router.push({ path: '/switchSubject' });
      } else {
        this.$router.push({ path: '/' });
      }
    },
    /**
     * @description: 检测登录情况
     * @param {*}
     * @return {*}
     */
    handleCheckLogin () {
      const hasToken = this.$HMCookies.get(config.localTokenName) || false;
      // 如果cookie 有token ，数据管理存在用户信息，且用户有登录身份信息，进入系统
      if (hasToken && this.currentUser && this.currentUser.capacity) {
        this.$router.push({ path: '/' });
      } else if (hasToken && this.currentUser && !this.currentUser.capacity) {
        // 如果cookie 有token ，数据管理存在用户信息，但是用户没有登录身份信息，跳转选择身份页面
        this.$router.push({ path: '/switchSubject' });
      } else {
        document.getElementById('preloading').style.display = 'none';
      }
    }
  },
  created () {
    this.handleCheckLogin();
  }
};

</script>

<style lang="scss">
</style>
